import { render } from "./UnidadeForm.vue?vue&type=template&id=5f683e84"
import script from "./UnidadeForm.vue?vue&type=script&lang=js"
export * from "./UnidadeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__